import { render, staticRenderFns } from "./activity_num.vue?vue&type=template&id=b308a034&scoped=true&"
import script from "./activity_num.vue?vue&type=script&lang=js&"
export * from "./activity_num.vue?vue&type=script&lang=js&"
import style0 from "./activity_num.vue?vue&type=style&index=0&id=b308a034&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b308a034",
  null
  
)

export default component.exports